import nflConstants from "./sports/nfl-constants";
import nbaConstants from "./sports/nba-constants";
import atpConstants from "./sports/atp-constants";
import wtaConstants from "./sports/wta-constants";
import mlbConstants from "./sports/mlb-constants";
import nhlConstants from "./sports/nhl-constants";
import ncaafConstants from "./sports/ncaaf-constants";
import ncaabConstants from "./sports/ncaab-constants";
import xflConstants from "./sports/xfl-constants";
import eplConstants from "./sports/epl-constants";
import mlsConstants from "./sports/mls-constants";
import uclConstants from "./sports/ucl-constants";
import espConstants from "./sports/esp-constants";
import itsaConstants from "./sports/itsa-constants";
import debConstants from "./sports/deb-constants";

export interface SEOContentItem {
  title: string;
  body: string;
}

export interface SEOContent {
  seoTitle: string;
  h1: string;
  items: SEOContentItem[];
}

export default {
  seoTitle: "BetQL | Sports Betting Picks, Predictions, and Articles",
  nfl: nflConstants,
  nba: nbaConstants,
  atp: atpConstants,
  wta: wtaConstants,
  mlb: mlbConstants,
  nhl: nhlConstants,
  ncaaf: ncaafConstants,
  ncaab: ncaabConstants,
  xfl: xflConstants,
  "premier-league": eplConstants,
  mls: mlsConstants,
  "champions-league": uclConstants,
  "la-liga": espConstants,
  "serie-a": itsaConstants,
  bundesliga: debConstants,
};
